import { useHistory, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';

import {
  isUserOnContractPage,
  isUserOnTemplatePage,
  isUserOnAdminPage,
  isUserOnGlobalSearchPage,
} from '@flow/libs/utils/isOnPage';
import { getCurrentWorkspaceSelector, selectWorkspace } from '@app/reducers/app';
import { withWorkspaceNamespace } from '@app/hocs/with-current-workspace/with-workspace-namespace';

export const useSwitchWorkspace = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;

  const currentWorkspace = useSelector(getCurrentWorkspaceSelector);
  const workspaceLocation = withWorkspaceNamespace({
    id: currentWorkspace.id,
  });
  const isOnContractsPage = window.location.pathname.includes('/contracts/all');
  const searchParams = new URLSearchParams(location.search);
  const hasSearchQuery = searchParams.size > 0;
  const isOnTemplatePage = isUserOnTemplatePage(pathname);
  const isOnAdminPage = isUserOnAdminPage(pathname);
  const isOnGlobalSearchPage = isUserOnGlobalSearchPage(pathname);

  const switchWorkspace = useCallback(
    (workspaceId: number) => {
      dispatch(
        selectWorkspace({
          workspaceId,
        }),
      );

      const isOnContractPage = isUserOnContractPage(pathname);
      // Logic handles when changing the workspace when in contract/template view
      // The saga navigateToWorkspace, is called when opening a contract which means that
      // if this logic is apart of the saga, it will directly redirect back to contract list
      if (isOnGlobalSearchPage || isOnAdminPage) {
        window.location.assign(`/c/${workspaceId}/contracts/all`);
      }

      if (isOnContractsPage && hasSearchQuery) {
        history.push(`/c/${workspaceId}/contracts/all`);
      }

      if (isOnContractPage || isOnTemplatePage) {
        const link = workspaceLocation('/contracts');
        window.location.assign(link);
      }
    },
    [
      dispatch,
      hasSearchQuery,
      history,
      isOnAdminPage,
      isOnContractsPage,
      isOnGlobalSearchPage,
      isOnTemplatePage,
      workspaceLocation,
      pathname,
    ],
  );

  return switchWorkspace;
};
